import { HeartHandshake, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

export const IMPACT_LINE =
  "A major portion of your purchase goes towards helping people facing serious health issues through recognised/authorised NGOs.";

export default function Impact() {
  return (
    <div className="max-w-5xl mx-auto px-5 lg:px-10 py-24" data-testid="impact-page">
      <div className="hy-label">HYLUNER Impact</div>
      <h1 className="font-display text-4xl sm:text-5xl text-white mt-5">
        A dedication above.<br />Real help below.
      </h1>

      <div className="hy-glass p-8 sm:p-10 mt-14 flex gap-5" data-testid="impact-statement">
        <HeartHandshake className="w-7 h-7 shrink-0" style={{ color: "var(--hy-gold)" }} strokeWidth={1.3} />
        <p className="font-serif-accent italic text-lg sm:text-xl text-amber-100 leading-relaxed">
          {IMPACT_LINE}
        </p>
      </div>

      <div className="mt-16 space-y-10">
        <Block title="Why we do this">
          HYLUNER exists to mark the moments that matter — a birth, a memory, a person you love. It felt
          wrong for that to be only a symbol. So a major portion of what you pay is directed towards
          supporting people who are facing serious health issues, through recognised and authorised
          non-governmental organisations.
        </Block>
        <Block title="How the contribution is directed">
          Contributions are made through NGOs that are formally recognised and authorised to operate. We
          choose where to direct support, and we do not route funds through unregistered intermediaries.
        </Block>
        <Block title="What we deliberately do not claim">
          We do not publish a guaranteed donation percentage, a guaranteed number of beneficiaries, named
          partner organisations, or any tax-deductibility benefit for your purchase. We will only ever state
          such details once they are verified and can be evidenced — the same transparency standard we apply
          to everything else in this registry.
        </Block>
        <Block title="Your purchase, plainly stated">
          What you receive is a permanent numbered registry record, a physical photo-framed certificate, a
          digital certificate and QR verification. Your registration remains a private commemorative record
          and is not a donation receipt, and it does not confer ownership of any celestial body.
        </Block>
      </div>

      <div className="hy-card p-8 mt-16 flex flex-col sm:flex-row items-start sm:items-center gap-6 justify-between">
        <div className="flex gap-4">
          <ShieldCheck className="w-6 h-6 shrink-0 text-amber-500/70" strokeWidth={1.4} />
          <p className="text-sm text-slate-400 max-w-xl leading-relaxed">
            Read the full transparency statement to see exactly what a HYLUNER registration does and does
            not include.
          </p>
        </div>
        <Link to="/transparency" className="hy-btn-ghost px-6 py-3 text-xs uppercase whitespace-nowrap"
          data-testid="impact-transparency-link">
          Transparency Statement
        </Link>
      </div>

      <Link to="/create" className="hy-btn inline-block px-9 py-4 text-xs uppercase mt-14" data-testid="impact-create-btn">
        Register a Dedication
      </Link>
    </div>
  );
}

const Block = ({ title, children }) => (
  <div>
    <h2 className="font-display text-xl sm:text-2xl text-amber-200/90">{title}</h2>
    <div className="hy-rule my-5" />
    <p className="text-sm text-slate-400 leading-relaxed max-w-3xl">{children}</p>
  </div>
);
